import { useScript } from 'usehooks-ts';

export const usePolyfills = () => {
  return useScript(
    'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?version=4.8.0&features=es2023%2Ces2022%2Ces2021',
    {
      removeOnUnmount: false,
    },
  );
};
